module.exports = __webpack_public_path__ + "img/thank_2021_tip2_small.b514757e.png";